import Loading from '@/common/components/Loading';
import { PageWrapper } from '@/common/styles/Wrappers';
import CandidateForm from './components/CandidateForm';
import CandidatesTable from './components/CandidatesTable';
import RecruitmentSearchBar from './components/RecruitmentSearchBar';
import useRecruitment from './hooks/useRecruitment';

const Recruitment = () => {
	const hook = useRecruitment();

	return (
		<PageWrapper>
			{hook.isLoading && <Loading />}
			<RecruitmentSearchBar
				setVisibleCandidates={hook.setVisibleCandidates}
				setShowCandidateForm={hook.setShowCandidateForm}
				candidates={hook.callCenterCandidates}
			/>
			{hook.showCandidateForm && (
				<CandidateForm
					callCenterPositionsOptions={hook.callCenterPositionsOptions}
					setShow={hook.setShowCandidateForm}
					selectedCandidate={hook.showCandidateForm}
					reload={hook.loadCandidates}
				/>
			)}
			<CandidatesTable
				setShowCandidateForm={hook.setShowCandidateForm}
				candidates={hook.visibleCandidates}
			/>
		</PageWrapper>
	);
};

export default Recruitment;
